<template>
  <div class="modal fade" id="deleteModal" data-toggle="modal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="deleteModalLabel">Are you sure?</h5>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary ms-2"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <span class="svg-icon svg-icon-2x"></span>
          </div>
        </div>

        <div class="modal-body">
          <p>Do you want to delete {{ currentlySelectedEntry }}?</p>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-light" data-bs-dismiss="modal">
            Close
          </button>
          <button
            @click="deleteButtonClicked"
            type="button"
            class="btn btn-danger"
            data-bs-dismiss="modal"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { Modal } from "bootstrap";
export default defineComponent({
  props: {
    currentlySelectedEntry: String
  },
  data() {
    return {
      modal: null,
      element: null
    };
  },
  methods: {
    deleteButtonClicked() {
      this.$emit("delete");
    },
    emitClose() {
      this.$emit("close");
    }
  },
  mounted() {
    this.element = document.getElementById("deleteModal");
    if (this.element) {
      this.modal = new Modal(this.element);
      this.element.addEventListener("hidden.bs.modal", this.emitClose);
    }
  },
  unmounted() {
    this.element.removeEventListener("hidden.bs.modal", this.emitClose);
  }
});
</script>
